import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslocoService } from '@jsverse/transloco';

import { SnackbarType } from './snackbar.enum';

@Injectable({ providedIn: 'root' })
export class SnackbarService {
  private _snackBar: MatSnackBar;
  private _translocoService: TranslocoService;

  constructor() {
    this._snackBar = inject(MatSnackBar);
    this._translocoService = inject(TranslocoService);
  }

  open(message: string, type: SnackbarType) {
    this._snackBar.open(
      message,
      this._translocoService.translate('messages.close'),
      {
        duration: 3000,
        panelClass: `ezv-snackbar--${type}`,
      }
    );
  }
}
